/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_TitleInputs */

const en_directory_hubs_signals_title = /** @type {(inputs: Directory_Hubs_Signals_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmarks`)
};

const zh_directory_hubs_signals_title = /** @type {(inputs: Directory_Hubs_Signals_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基准评分`)
};

/**
* | output |
* | --- |
* | "Benchmarks" |
*
* @param {Directory_Hubs_Signals_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_title = /** @type {((inputs?: Directory_Hubs_Signals_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_title(inputs)
	return zh_directory_hubs_signals_title(inputs)
});
export { directory_hubs_signals_title as "directory.hubs.signals.title" }